<template>
  <div :class="widgetClasses" class="card">
    <div class="card-body p-0">
      <div
        :class="`bg-${widgetColor}`"
        class="px-9 pt-7 card-rounded bgi-no-repeat bgi-position-x-end h-275px w-100"
        style="
          background-color: #f1416c;
          background-image: url('media/svg/shapes/wave-bg-red.svg');
        "
      >
        <div class="d-flex flex-stack">
          <h3 class="m-0 text-white fw-bold fs-3">Resumo Operacional</h3>
          <div class="ms-1">
            <button
              type="button"
              :class="`btn-active-color-${widgetColor}`"
              class="btn btn-sm btn-icon btn-color-white btn-active-light-primary border-0 me-n3"
              data-toggle="tooltip"
              data-placement="top"
              title="Atualizar"
              @click="this.carregarTotalizadores()"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div
        class="bg-body shadow-sm card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1"
        style="margin-top: -150px"
      >
        <template v-for="(item, index) in items" :key="index">
          <div
            v-if="!loading"
            :class="[index !== items.length && 'mb-7']"
            class="d-flex align-items-center"
          >
            <div class="symbol symbol-45px w-40px me-5">
              <span class="symbol-label bg-lighten">
                <span class="svg-icon svg-icon-1" :class="item.iconColor">
                  <inline-svg :src="item.icon" />
                </span>
              </span>
            </div>
            <div class="d-flex align-items-center flex-wrap w-100">
              <div class="mb-1 pe-3 flex-grow-1">
                <a
                  href="#"
                  class="fs-5 text-gray-800 text-hover-primary fw-bold"
                  >{{ item.title }}</a
                >
                <div class="text-gray-400 fw-semobold fs-7">
                  {{ item.description }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="fw-bold fs-5 text-gray-800 pe-1">
                  {{ item.stats }}
                </div>

                <span
                  v-if="item.arrow === 'up'"
                  class="svg-icon svg-icon-5 svg-icon-success ms-1"
                >
                  <inline-svg src="media/icons/duotune/arrows/arr066.svg" />
                </span>
                <span
                  v-else-if="item.arrow === 'down'"
                  class="svg-icon svg-icon-5 svg-icon-danger ms-1"
                >
                  <inline-svg src="media/icons/duotune/arrows/arr065.svg" />
                </span>
              </div>
            </div>
          </div>
        </template>
        <div v-if="loading" v-bind:data-kt-indicator="loading ? 'on' : 'off'">
          <span class="indicator-progress">
            Aguarde, carregando...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    widgetColor: { type: String, required: false, default: "danger" },
    widgetClasses: {
      type: String,
      required: false,
      default: "card-xl-stretch mb-xl-8",
    },
    chartHeight: { type: Number, required: false, default: 0 },
  },
  methods: {
    async carregarTotalizadores() {
      this.loading = true;
      this.items = [];
      try {
        let retProdutos = await this.$store.dispatch(
          "produto/getProdutoOData",
          "/$count"
        );

        if (retProdutos && retProdutos !== null) {
          this.items.push({
            icon: "media/icons/duotune/ecommerce/ecm009.svg",
            title: "Produtos",
            description: "Total de produtos cadastrados",
            stats: retProdutos,
            arrow: "up",
            iconColor: "svg-icon-success",
          });
        }

        let retClientes = await this.$store.dispatch(
          "cliente/getClienteOData",
          "/$count"
        );

        if (retClientes && retClientes !== null) {
          this.items.push({
            icon: "media/icons/duotune/communication/com005.svg",
            title: "Clientes",
            description: "Total de clientes cadastrados",
            stats: retClientes,
            arrow: "up",
            iconColor: "svg-icon-warning",
          });
        }

        let retFaturamentos = await this.$store.dispatch(
          "faturamento/getFaturamentoOData",
          "/$count"
        );

        if (retFaturamentos && retFaturamentos !== null) {
          this.items.push({
            icon: "media/icons/duotune/ecommerce/ecm008.svg",
            title: "Faturamentos",
            description: "Total de faturamentos",
            stats: retFaturamentos,
            arrow: "up",
            iconColor: "svg-icon-primary",
          });
        }

        let retFaturamentosCancelados = await this.$store.dispatch(
          "faturamento/getFaturamentoOData",
          "?$count=true&$filter=cancelado eq '1'&$top=0"
        );

        if (retFaturamentosCancelados && retFaturamentosCancelados !== null) {
          this.items.push({
            icon: "media/icons/duotune/ecommerce/ecm008.svg",
            title: "Faturamentos Cancelados",
            description: "Total de faturamentos cancelados",
            stats: retFaturamentosCancelados["@odata.count"],
            arrow: "up",
            iconColor: "svg-icon-danger",
          });
        }

        let retFaturamentosPendentes = await this.$store.dispatch(
          "faturamento/getFaturamentoOData",
          "?$count=true&$filter=status_nfe eq 'Em Digitação'&$top=0"
        );

        if (retFaturamentosPendentes && retFaturamentosPendentes !== null) {
          this.items.push({
            icon: "media/icons/duotune/abstract/abs007.svg",
            title: "NF-e",
            description: "Total de NF-e pendentes",
            stats: retFaturamentosPendentes["@odata.count"],
            arrow: "up",
            iconColor: "svg-icon-info",
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.carregarTotalizadores();
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
};
</script>

<style lang="scss" scoped></style>
